export default "__VITE_ASSET__cacf8545__"